import comp from "./FileViewer";
export default comp;
